// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/shortfall.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "./date";
/**
 * The smallest changes that stop a plan running short, found by re-running the plan with one input
 * changed (engine FindShortfallFixes). Computed as a separate job after a plan that has a
 * CASH_SHORTFALL event. Not part of FinancialPlanData: these are counterfactual runs, not facts of
 * the plan.
 *
 * @generated from protobuf message core.v1.ShortfallFix
 */
export interface ShortfallFix {
    /**
     * @generated from protobuf field: core.v1.ShortfallFix.Type type = 1;
     */
    type: ShortfallFix_Type;
    /**
     * @generated from protobuf field: double amount = 2;
     */
    amount: number; // monthly for income and expense fixes; one-off for a lump sum
    /**
     * @generated from protobuf field: core.v1.Date start_date = 3;
     */
    startDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date end_date = 4;
     */
    endDate?: Date;
    /**
     * @generated from protobuf field: double closes_amount = 5;
     */
    closesAmount: number; // how much of the original shortfall this closes
    /**
     * @generated from protobuf field: core.v1.Date new_shortfall_date = 6;
     */
    newShortfallDate?: Date; // unset when the fix closes the shortfall entirely
}
/**
 * @generated from protobuf enum core.v1.ShortfallFix.Type
 */
export enum ShortfallFix_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * gross, from start_date until end_date (retirement)
     *
     * @generated from protobuf enum value: TYPE_EXTRA_MONTHLY_INCOME = 1;
     */
    EXTRA_MONTHLY_INCOME = 1,
    /**
     * lifestyle spending first, then essentials
     *
     * @generated from protobuf enum value: TYPE_MONTHLY_EXPENSE_CUT = 2;
     */
    MONTHLY_EXPENSE_CUT = 2,
    /**
     * one deposit into chequing on start_date
     *
     * @generated from protobuf enum value: TYPE_LUMP_SUM_TODAY = 3;
     */
    LUMP_SUM_TODAY = 3
}
/**
 * @generated from protobuf message core.v1.ShortfallFixes
 */
export interface ShortfallFixes {
    /**
     * @generated from protobuf field: core.v1.Date shortfall_date = 1;
     */
    shortfallDate?: Date;
    /**
     * @generated from protobuf field: double shortfall_amount = 2;
     */
    shortfallAmount: number;
    /**
     * @generated from protobuf field: repeated core.v1.ShortfallFix fixes = 3;
     */
    fixes: ShortfallFix[];
    /**
     * @generated from protobuf field: int32 simulations_run = 4;
     */
    simulationsRun: number;
    /**
     * @generated from protobuf field: string engine_version = 5;
     */
    engineVersion: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ShortfallFix$Type extends MessageType<ShortfallFix> {
    constructor() {
        super("core.v1.ShortfallFix", [
            { no: 1, name: "type", kind: "enum", T: () => ["core.v1.ShortfallFix.Type", ShortfallFix_Type, "TYPE_"] },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "start_date", kind: "message", T: () => Date },
            { no: 4, name: "end_date", kind: "message", T: () => Date },
            { no: 5, name: "closes_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "new_shortfall_date", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ShortfallFix
 */
export const ShortfallFix = new ShortfallFix$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShortfallFixes$Type extends MessageType<ShortfallFixes> {
    constructor() {
        super("core.v1.ShortfallFixes", [
            { no: 1, name: "shortfall_date", kind: "message", T: () => Date },
            { no: 2, name: "shortfall_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "fixes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ShortfallFix },
            { no: 4, name: "simulations_run", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "engine_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ShortfallFixes
 */
export const ShortfallFixes = new ShortfallFixes$Type();
